import { Grid, Typography, Button, Card, Grid2 } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router';
import docRegister from 'src/assets/doctor-register.webp'; // Make sure the path is correct

// Styled container for full height
const FullHeightGrid = styled(Grid)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: theme.palette.grey[100],
}));

const DoctorIntroPage = () => {
  const navigate = useNavigate();

  return (
    <FullHeightGrid container>
      {/* Left Side Image */}
        <Grid2 size={{ xs: 12, md: 4, lg: 5 }} display={{ xs: 'none', md: 'flex' }} justifyContent={'center'} alignItems={'center'} >
                <img src={docRegister} alt={'doc'} style={{ objectFit: 'contain' }} />
            </Grid2> 
      <Grid
        item
        xs={12}
        md={6}
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={{ xs: 2, md: 4 }}
      >
        <Card
          elevation={3}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            maxWidth: 600,
            width: '100%',
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            fontWeight="bold"
            color="primary"
          >
            Your Expertise Can Transform Lives
          </Typography>

          <Typography variant="body1" gutterBottom>
            Are you ready to expand your impact, connect with more patients,
            and streamline your medical practice?
          </Typography>

          <Typography variant="body1" gutterBottom>
            ✅ Join a trusted platform built exclusively for Australian
            healthcare professionals.
          </Typography>

          <Typography variant="body1" gutterBottom>
            ✅ Easy, fast, and secure doctor registration process.
          </Typography>

          <Typography variant="body2" color="text.secondary" mt={3}>
            Questions to consider:
          </Typography>

          <ul style={{ paddingLeft: '1.2em' }}>
            <li>
              <Typography variant="body2">
                Are you looking to grow your patient base?
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Do you want a secure digital platform to manage your
                credentials?
              </Typography>
            </li>
            <li>
              <Typography variant="body2">
                Would you like to be part of a verified network of
                professionals?
              </Typography>
            </li>
          </ul>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 4 }}
            onClick={() => navigate('/doctor-interset-expression')}
          >
            Go to Doctor Registration
          </Button>
        </Card>
      </Grid>
    </FullHeightGrid>
  );
};

export default DoctorIntroPage;
